namespace Matrix.Workflow {
    export interface WorkflowInstanceForm {
        WorkflowCode: Serenity.LookupEditor;
        TriggerCode: Serenity.LookupEditor;
        CreatedDate: Serenity.DateEditor;
        StatusCode: Serenity.LookupEditor;
        StartedWhen: Serenity.DateTimeEditor;
        FinishedWhen: Serenity.DateTimeEditor;
        Key1: Serenity.StringEditor;
        Key2: Serenity.StringEditor;
        Key3: Serenity.StringEditor;
        Key4: Serenity.StringEditor;
        Key5: Serenity.StringEditor;
        C1: Serenity.StringEditor;
        C2: Serenity.StringEditor;
        C3: Serenity.StringEditor;
        C4: Serenity.StringEditor;
        C5: Serenity.StringEditor;
        C6: Serenity.StringEditor;
        C7: Serenity.StringEditor;
        C8: Serenity.StringEditor;
        C9: Serenity.StringEditor;
        C10: Serenity.StringEditor;
        B1: Serenity.BooleanEditor;
        B2: Serenity.BooleanEditor;
        B3: Serenity.BooleanEditor;
        B4: Serenity.BooleanEditor;
        B5: Serenity.BooleanEditor;
        B6: Serenity.BooleanEditor;
        B7: Serenity.BooleanEditor;
        B8: Serenity.BooleanEditor;
        B9: Serenity.BooleanEditor;
        B10: Serenity.BooleanEditor;
        N1: Serenity.IntegerEditor;
        N2: Serenity.IntegerEditor;
        N3: Serenity.IntegerEditor;
        N4: Serenity.IntegerEditor;
        N5: Serenity.IntegerEditor;
        N6: Serenity.IntegerEditor;
        N7: Serenity.IntegerEditor;
        N8: Serenity.IntegerEditor;
        N9: Serenity.IntegerEditor;
        N10: Serenity.IntegerEditor;
        F1: Serenity.DecimalEditor;
        F2: Serenity.DecimalEditor;
        F3: Serenity.DecimalEditor;
        F4: Serenity.DecimalEditor;
        F5: Serenity.DecimalEditor;
        F6: Serenity.DecimalEditor;
        F7: Serenity.DecimalEditor;
        F8: Serenity.DecimalEditor;
        F9: Serenity.DecimalEditor;
        F10: Serenity.DecimalEditor;
        D1: Serenity.DateTimeEditor;
        D2: Serenity.DateTimeEditor;
        D3: Serenity.DateTimeEditor;
        D4: Serenity.DateTimeEditor;
        D5: Serenity.DateTimeEditor;
        Txt1: Serenity.TextAreaEditor;
        Txt2: Serenity.TextAreaEditor;
        Txt3: Serenity.TextAreaEditor;
        Txt4: Serenity.TextAreaEditor;
        Txt5: Serenity.TextAreaEditor;
        Properties: Serenity.TextAreaEditor;
        Documents: WorkflowInstanceDocumentGrid;
        Tasks: WorkflowInstanceTaskInstanceGrid;
        CorrelationId: Serenity.StringEditor;
        DurationMs: Serenity.StringEditor;
        StdOut: Serenity.TextAreaEditor;
        StdErr: Serenity.TextAreaEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class WorkflowInstanceForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.WorkflowInstance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WorkflowInstanceForm.init)  {
                WorkflowInstanceForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DateEditor;
                var w2 = s.DateTimeEditor;
                var w3 = s.StringEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.TextAreaEditor;
                var w8 = WorkflowInstanceDocumentGrid;
                var w9 = WorkflowInstanceTaskInstanceGrid;
                var w10 = StaticTextBlock;
                var w11 = ReadOnlyDateTime;

                Q.initFormType(WorkflowInstanceForm, [
                    'WorkflowCode', w0,
                    'TriggerCode', w0,
                    'CreatedDate', w1,
                    'StatusCode', w0,
                    'StartedWhen', w2,
                    'FinishedWhen', w2,
                    'Key1', w3,
                    'Key2', w3,
                    'Key3', w3,
                    'Key4', w3,
                    'Key5', w3,
                    'C1', w3,
                    'C2', w3,
                    'C3', w3,
                    'C4', w3,
                    'C5', w3,
                    'C6', w3,
                    'C7', w3,
                    'C8', w3,
                    'C9', w3,
                    'C10', w3,
                    'B1', w4,
                    'B2', w4,
                    'B3', w4,
                    'B4', w4,
                    'B5', w4,
                    'B6', w4,
                    'B7', w4,
                    'B8', w4,
                    'B9', w4,
                    'B10', w4,
                    'N1', w5,
                    'N2', w5,
                    'N3', w5,
                    'N4', w5,
                    'N5', w5,
                    'N6', w5,
                    'N7', w5,
                    'N8', w5,
                    'N9', w5,
                    'N10', w5,
                    'F1', w6,
                    'F2', w6,
                    'F3', w6,
                    'F4', w6,
                    'F5', w6,
                    'F6', w6,
                    'F7', w6,
                    'F8', w6,
                    'F9', w6,
                    'F10', w6,
                    'D1', w2,
                    'D2', w2,
                    'D3', w2,
                    'D4', w2,
                    'D5', w2,
                    'Txt1', w7,
                    'Txt2', w7,
                    'Txt3', w7,
                    'Txt4', w7,
                    'Txt5', w7,
                    'Properties', w7,
                    'Documents', w8,
                    'Tasks', w9,
                    'CorrelationId', w3,
                    'DurationMs', w3,
                    'StdOut', w7,
                    'StdErr', w7,
                    'CreatedBy', w10,
                    'CreatedWhen', w11,
                    'UpdatedBy', w10,
                    'UpdatedWhen', w11,
                    'Version', w10
                ]);
            }
        }
    }
}
